import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const apiUrl = "index.php";
const ARCHIVED = 1;
const NOT_ARCHIVED = 0;

const setScheduleArchiveStatus = (state, scheduleId, status) => {
    const schedule = state.schedules.find((s) => s.id === scheduleId);
    schedule.is_archive = status;
};

const state = () => ({
    schedules: [],
});

const mutations = {
    setSchedules(state, schedules) {
        state.schedules = schedules;
    },
    putNewSchedule(state, schedule) {
        state.schedules.unshift(schedule);
    },
    updateSchedule(state, scheduleData) {
        const schedule = state.schedules.find((s) => s.id === scheduleData.id);
        Object.keys(schedule).forEach((key) => {
            schedule[key] = scheduleData[key];
        });
    },
    deleteSchedule(state, scheduleId) {
        state.schedules = state.schedules.filter((s) => s.id !== scheduleId);
    },
    moveScheduleToArchive(state, scheduleId) {
        setScheduleArchiveStatus(state, scheduleId, ARCHIVED);
    },
    moveScheduleFromArchive(state, scheduleId) {
        setScheduleArchiveStatus(state, scheduleId, NOT_ARCHIVED);
    },
};

const actions = {
    async fetchSchedules({ rootState, commit }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/index&sort=-sort`, token);

        const { data } = await axios.get(url);
        commit("setSchedules", data);
    },
    async createSchedule({ rootState, commit }, scheduleData) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/create`, token);

        const { data } = await axios.post(url, scheduleData);

        if (data.success) {
            commit("putNewSchedule", data.model);
        }

        return data.success;
    },
    async updateSchedule({ rootState, commit }, scheduleData) {
        const token = rootState.authToken;
        const scheduleId = scheduleData.id;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/update&id=${scheduleId}`, token);

        const { data } = await axios.put(url, scheduleData);

        if (data.success) {
            commit("updateSchedule", data.model);
        }

        return data.success;
    },
    async deleteSchedule({ rootState, commit }, scheduleId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/delete&id=${scheduleId}`, token);

        const { data } = await axios.delete(url);

        if (data.success) {
            commit("deleteSchedule", scheduleId);
        }
    },
    async moveScheduleToArchive({ rootState, commit }, scheduleId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/archive&id=${scheduleId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveScheduleToArchive", scheduleId);
        }
        return data.success;
    },
    async moveScheduleFromArchive({ rootState, commit }, scheduleId) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/unarchive&id=${scheduleId}`, token);

        const { data } = await axios.patch(url);

        if (data.success) {
            commit("moveScheduleFromArchive", scheduleId);
        }

        return data.success;
    },
    async updateSort({ rootState, state }) {
        const token = rootState.authToken;
        const url = addAuthKey(`${apiUrl}/?r=api/schedule/update-sort`, token);

        const sortingData = state.schedules.map((s, sIndex) => ({ id: s.id, sort: state.schedules.length - sIndex }));

        await axios.patch(url, sortingData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
